import { render, staticRenderFns } from "./Champions.vue?vue&type=template&id=21849e4a&"
import script from "./Champions.vue?vue&type=script&lang=js&"
export * from "./Champions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports